import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from "html-react-parser";
import { variables } from './Variables.js';
import TrendingList_Ar from './TrendingList_Ar.js';
import TrendingList_Ar2 from './TrendingList_Ar2.js';
export default function TrendingNewsCoins_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        const newArray = [];
        for (let i = 3; i <= 10 && i < response.data.length; i++) {
          newArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,
          });
        }
        setJsonArray(newArray); 
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>
    

        <div className="row trending-news-slider slick-initialized slick-slider">

          <div className="slick-list draggable ">
            <div className=" slick-track col     container "  >
              <div className="section-title">
                <h3 className="title float-right">اخر الأخبار</h3>
                <br></br>

              </div>
              {/* Start from here  */}
              {JsonArray.map(da =>
                <div key={da.news_title}  >
                  <div className="col-lg-6 col-lg-6 col-md-6 col-sm-12  slick-slide slick-cloned   " data-slick-index={4} aria-hidden="true" tabIndex={-1} style={{ width: '380px' }}>
                    <div className="trending-news-item">
                      <div className="trending-news-thumb">
                        <a href={da.link}>
                          <img className=' ' style={{ maxWidth: '350px', height: 'auto' }} src={da.news_imagename} alt="trending" />
                        </a>
                      </div>
                      <div className="trending-news-content ">
                        <div className="post-meta float-right" >
                           <div className="meta-date ">
                            <span>{da.news_date}</span>
                          </div>
                          <div className="meta-categories ">
                            <a tabIndex={-1}>{da.Category}</a>
                          </div>
                         
                        </div>
                        <br></br> <br></br>
                        <h3 className="title Arabic-text"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h3>
                        <p className="text Arabic-text">{parse(da.Description)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

        

              {/* End from here  */}
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="trending-news-post-items">
                  <TrendingList_Ar />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="trending-news-post-items">
                  <TrendingList_Ar2 />
                </div>
              </div>
            </div>

          </div>
        </div>

      
    </>
  );
}



